import { render, staticRenderFns } from "./HorizontalArrowBarChart.vue?vue&type=template&id=02d2a6f0&"
import script from "./HorizontalArrowBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalArrowBarChart.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalArrowBarChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d2a6f0')) {
      api.createRecord('02d2a6f0', component.options)
    } else {
      api.reload('02d2a6f0', component.options)
    }
    module.hot.accept("./HorizontalArrowBarChart.vue?vue&type=template&id=02d2a6f0&", function () {
      api.rerender('02d2a6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HorizontalArrowBarChart.vue"
export default component.exports